let { View, Utils } = window.App;

import 'owl.carousel';

const SELECTOR = '.js-slider';

class Slider{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        this.$el.owlCarousel( this.getOptions() ).addClass( 'owl-carousel' );
    }

    getOptions(){
        return $.extend( {
            items     : 1,
            autoHeight: true,
            loop      : true,
            nav       : true,
            dots      : true,
            navText   : [ Utils.icon( 'arrow-left' ), Utils.icon( 'arrow-right' ) ],
        }, this.$el.data( 'slider-options' ) || {} );
    }
}

View.addHook( 'init', v => {
    v.$( SELECTOR ).each( function(){
        new Slider( this );
    } );
} );



// WEBPACK FOOTER //
// ./resources/js/modules/slider.js